import { Injectable, inject } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { VOLCANIC_LEGEND } from './volcanic.legend';
import { VolcanicAshCloudsPluginService } from './volcanic-ash-clouds/volcanic-ash-clouds.plugin.service';
import { VolcanicPointsPluginService } from './volcanic-points/volcanic-points.plugin.service';

@Injectable({
  providedIn: 'root'
})
export class VolcanicPluginService {
  private readonly _volcanicPointsPlugin$ = inject(VolcanicPointsPluginService);
  private readonly _volcanicAshCloudsPlugin$ = inject(
    VolcanicAshCloudsPluginService
  );

  plugin$ = combineLatest([
    this._volcanicPointsPlugin$.plugin$,
    this._volcanicAshCloudsPlugin$.plugin$
  ]).pipe(
    map(
      (children) =>
        new Plugin({
          id: 'volcanic',
          legend: VOLCANIC_LEGEND,
          children
        })
    )
  );
}
